export const GET_TERMS = 'GET_TERMS'
export const GET_TERM_SINGLE = 'GET_TERM_SINGLE'
export const ADD_TERM = 'ADD_TERM'
export const UPDATE_TERM = 'UPDATE_TERM'
export const DELETE_SINGLE_TERM = 'DELETE_SINGLE_TERM'
export const DELETE_MANY_TERMS = 'DELETE_MANY_TERMS'
export const LOCK_UNLOCK_TERMS = 'LOCK_UNLOCK_TERMS'
